import React from 'react';
import styled from 'styled-components';
import { colors } from 'styleguide/colors';
import { CornerRadius, Spacing } from 'styleguide/spacing';
import { P4 } from 'styleguide/Texts';
import { getSupersetColor } from 'styleguide/colors';
import { View } from 'styleguide/View';
import { t } from 'translations/t';

const Container = styled(View)`
  height: 20px;
  padding: 0 ${Spacing.sm}px;
  border-radius: ${CornerRadius.xs}px;
  align-items: center;
  justify-content: center;
`;

export const SupersetChicklet = ({ id }: { id: number }) => (
  <Container style={{ backgroundColor: getSupersetColor(id) }}>
    <P4 style={{ color: colors.white }}>{t('web.supersetChicklet.superset')}</P4>
  </Container>
);
